export const blockIconsCommonactionsStarsNew = (
	<span className='material-symbols-outlined'>stars</span>
);
